import { useCallback } from 'react';
import { useFeConfig } from '@laigu/component';

import { useSelector, useDispatch } from '../../../react-redux';
import { mergeConvSetting } from '../../../reducers/conv-setting';

const useConvSetting = () => {
  const { getFeConfig: getConvSettingApi, updateFeConfig: updateConvSettingApi } = useFeConfig({
    key: 'conv_setting'
  });
  const convSetting = useSelector(state => state.getIn(['convSetting']));
  const dispatch = useDispatch();

  const handleUpdateConvSetting = useCallback(data => {
    const stringData = JSON.stringify(data);
    return updateConvSettingApi(stringData).then(res => {
      if (res?.data) {
        dispatch(mergeConvSetting(data));
      }
      return res;
    });
  }, []);

  const handleGetConvSetting = useCallback(
    () =>
      getConvSettingApi().then(res => {
        if (res?.data?.conv_setting) {
          const setting = JSON.parse(res.data.conv_setting);
          dispatch(mergeConvSetting(setting));
        }
      }),
    []
  );

  return {
    convSetting,
    handleGetConvSetting,
    handleUpdateConvSetting
  };
};

export default useConvSetting;
